import React, {useEffect} from "react";
import {withStyles} from "@material-ui/styles";
import DataGrid, {Column, LoadPanel, Scrolling, Selection} from "devextreme-react/data-grid";
import Typography from "@material-ui/core/Typography";
import { Alert, AlertTitle } from '@material-ui/lab';
import StaffDataSelect from "../../../../../components/StaffDataSelect";
import Avatar from "../../../../../../ui/Avatar";
import useRoles from "../../../../../hooks/useRoles.js";

const styles = () => ({
  root: {
    "& .MuiFormLabel-root": {
      whiteSpace: "nowrap"
    },
    "& .MuiInputBase-input.Mui-disabled": {
      color: "#000"
    }
  },
  rootTable: {
    display: "flex",
    flexDirection: "row",
    "& #gridContainer": {
      height: "240px"
    }
  },
  heading: {
    fontSize: 14,
    display: "flex",
    alignItems: "center",
    color: "#000000",
    margin: "25px 0 15px 0"
  },
  avatarContainer: {
    display: "flex",
    alignItems: "left",
    '& span': {
      marginTop: 8,
      marginLeft: 8
    }
  }
});

const defaultData = {
  personId: -1,
  roles: []
};

const KuratorEditForm = ({
                           disabled,
                           onFormChange,
                           classes,
                           orgId,
                           curatorId
                         }) => {

  const {dataSources, getRoles, getPersons, getPersonRoles} = useRoles();

  const initialData = (curatorId && curatorId>-1) ? { personId: curatorId, roles: [] } : null;
  const [data, setData] = React.useState(initialData || defaultData);
  const {personId, roles} = data;
  const dataGridRef = React.createRef();

  useEffect(() => {
    getRoles();
    getPersons(orgId);
  }, [orgId]);

  useEffect(() => {
    if (personId && personId !== -1) {
      getPersonRoles(personId);
    }
  }, [personId]);

  useEffect(() => {
    let rolesInfo =  dataSources.personroles || [];
    const newState = {
      personId,
      roles: rolesInfo.map(r => r.id)
    };
    setData(newState);
    onFormChange(newState);
  }, [dataSources.personroles]);

  const onPersonChange = (personId) => {
    const newState = {personId: personId, roles: []};
    setData(newState);
    onFormChange(newState);
  };

  const selectRoles = (ev) => {
    const newState = {
      personId,
      roles: ev.selectedRowKeys
    };
    setData(newState);
    onFormChange(newState);
  };

  return (
    <div className={classes.root}>
      {(dataSources.persons && dataSources.persons.length>0) ? <>
      <StaffDataSelect
        value={personId}
        onChange={value => onPersonChange(value.personId)}
        label="Выберите сотрудника"
        dataSource={dataSources.persons}
        disabled={disabled}
        renderTags={option => (
          <div className={classes.avatarContainer}>
            <Avatar imageId={option.avatar}/>
            <span>{option.name}</span>
          </div>
        )}
        renderOption={option => (
          <div className={classes.avatarContainer}>
            <Avatar imageId={option.avatar}/>
            <span>{option.name}</span>
          </div>
        )}
      />

      <Typography className={classes.heading}>Роли куратора</Typography>
      <div className={classes.rootTable}>
        <DataGrid
          elementAttr={{
            id: "gridContainer"
          }}
          ref={dataGridRef}
          wordWrapEnabled={true}
          dataSource={dataSources.roles}
          onSelectionChanged={selectRoles}
          keyExpr="id"
          selectedRowKeys={roles}
          errorRowEnabled={false}
          showBorders
          disabled={!personId || personId<0}
        >
          <Selection
            mode="multiple"
            showCheckBoxesMode="onClick"
            showBorders={true}
            width={120}
          />
          <Column
            dataField="id"
            caption="ID"
            dataType="number"
            align="left"
            width={60}
          />
          <Column
            dataField="name"
            caption="Наименование"
            dataType="string"
          />
          <Scrolling mode="virtual"/>
          <LoadPanel enabled/>
        </DataGrid>
      </div></>
    :
      <Alert severity="info">
        <AlertTitle>Список сотрудников организации пуст</AlertTitle>
        Необходимо заполнить орг.структуру
      </Alert>}
    </div>
  );
};

export default withStyles(styles)(KuratorEditForm);
